import { render, staticRenderFns } from "./WrapperWrhsMngt.vue?vue&type=template&id=a349b1d8"
import script from "./WrapperWrhsMngt.vue?vue&type=script&lang=js"
export * from "./WrapperWrhsMngt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports